import type { AIModel, Job } from '@volt/shared';

const VEO_ORIGIN_MODEL_IDS = new Set(['google:veo-3.1', 'google:veo-3.1-fast', 'google:veo-3.1-lite']);

export interface VideoLibraryAssetOption {
  assetId: string;
  jobId: string;
  providerJobId?: string | null;
  name?: string | null;
  previewUrl?: string | null;
  durationSeconds?: number | null;
  originModelId?: string | null;
  originProvider?: string | null;
  displayName: string;
  originDisplayName: string;
}

function getJobResultUrls(job: Job): string[] {
  if (Array.isArray(job.resultUrls) && job.resultUrls.length > 0) return job.resultUrls;
  return job.resultUrl ? [job.resultUrl] : [];
}

function deriveAssetName(url: string, fallback: string): string {
  try {
    const parsed = new URL(url);
    const lastSegment = parsed.pathname.split('/').filter(Boolean).pop();
    return lastSegment && lastSegment.length > 0 ? decodeURIComponent(lastSegment) : fallback;
  } catch {
    return fallback;
  }
}

export function buildVeoLibraryAssets(jobs: Job[], models: AIModel[]): VideoLibraryAssetOption[] {
  const modelNames = new Map(models.map((model) => [model.id, model.displayName]));

  return jobs.flatMap((job) => {
    if (job.status !== 'done' || !VEO_ORIGIN_MODEL_IDS.has(job.modelId)) return [];
    const resultUrls = getJobResultUrls(job);
    if (resultUrls.length === 0) return [];

    const originDisplayName = modelNames.get(job.modelId) ?? job.modelId;
    const originProvider = job.modelId.split(':')[0] ?? null;

    return resultUrls.map((previewUrl, index) => ({
      assetId: `${job.id}:${index}`,
      jobId: job.id,
      providerJobId: job.providerJobId,
      name: deriveAssetName(previewUrl, `${originDisplayName} #${index + 1}`),
      displayName: deriveAssetName(previewUrl, `${originDisplayName} #${index + 1}`),
      previewUrl,
      originModelId: job.modelId,
      originProvider,
      originDisplayName,
    }));
  });
}
